function getErrorMessage(error) {
	let errorMsg = 'There was a problem processing your request.';

	if (error.response) {
		if (error.response.status === 401) {
			errorMsg = 'Your session has expired. Please log in again.';
		}
		else if (error.response.status === 403) {
			errorMsg = 'You do not have rights to view the requested information.';
		}
		else if (error.response.data && error.response.data.message) {
			errorMsg = error.response.data.message;
		}
		else if (error.response.data && typeof error.response.data === 'string') {
			errorMsg = error.response.data;
		}
		else if (error.message && typeof error.message === 'string') {
			errorMsg = error.message;
		}
	}

	return errorMsg;
}

export default {
	getErrorMessage
};